<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}
                </router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{ responseError }}</span>
              </v-flex>
              <v-flex :class="qc.id ? 'sm12' : 'sm6'">
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    label="Issue Date"
                    type="text"
                    prepend-icon="event"
                    v-model="issueDate"
                    readonly
                    :rules="rules.issueDateRules"
                  ></v-text-field>
                  <v-date-picker
                    v-model="issueDate"
                    :rules="rules.issueDateRules"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="qc.id">
                <v-text-field
                  name="issueNo"
                  label="Issue No"
                  v-model="qc.issueNo"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="qcNo"
                  label="QC No"
                  v-model="qc.qcNo"
                  type="text"
                  :rules="rules.qcNoRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="qc.warehouseId"
                  :items="warehouseList"
                  color="blue-grey lighten-2"
                  label="Choose Warehouse..."
                  item-text="name"
                  menu-props="auto"
                  item-value="id"
                  @change="changeWarehouse"
                  :readonly="!!user.warehouseId"
                  :rules="rules.warehouseRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-layout>
                  <v-flex xs9>
                    <v-text-field
                      name="poNo"
                      label="PO No"
                      v-model="qc.purchaseOrderNo"
                      type="text"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs>
                    <v-btn
                      outline
                      color="warning"
                      @click="showPurchaseOrderDialog = true"
                      :disabled="!qc.warehouseId || status != 'DRAFT'"
                    >
                      <v-icon dark>search</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm6>
                <v-select
                  :items="statusList"
                  label="Status"
                  item-text="label"
                  item-value="value"
                  v-model="qc.status"
                ></v-select>
              </v-flex>
              <v-flex sm6>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    label="Received Date"
                    type="text"
                    prepend-icon="event"
                    v-model="receivedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="receivedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12>
                <v-textarea
                  name="remark"
                  label="Remark"
                  v-model="qc.remark"
                ></v-textarea>
              </v-flex>

              <v-flex xs12>
                <v-card>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex sm4>
                        <v-select
                          v-if="qc.purchaseOrderId"
                          :items="purchaseOrderItemList"
                          label="Product"
                          item-text="productName"
                          item-value="id"
                          v-model="qc.purchaseOrderItemId"
                          @change="changePurchaseOrderItem"
                          :rules="rules.productNameRules"
                        ></v-select>
                        <v-text-field
                          v-else
                          name="productName"
                          label="Product Name"
                          placeholder="Choose product ..."
                          v-model="qc.productName"
                          @click="showProductList"
                          :rules="rules.productNameRules"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex sm4>
                        <v-text-field
                          name="productCode"
                          label="Product Code"
                          v-model="qc.productCode"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex sm4>
                        <v-autocomplete
                          v-model="qc.factorUnitName"
                          :hide-no-data="true"
                          :items="qc.productUnits"
                          label="Unit"
                          item-value="factorUnitName"
                          item-text="factorUnitName"
                          menu-props="auto"
                          :rules="rules.unitRules"
                          @change="changeUnit"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex sm4>
                        <v-text-field
                          name="qcQty"
                          label="Qty"
                          v-model="qc.qcQty"
                          type="number"
                          :rules="rules.qtyRules"
                        ></v-text-field>
                      </v-flex>
                      <v-flex sm4>
                        <v-text-field
                          name="remainingQty"
                          label="Remaining Qty"
                          v-model="remainingQty"
                          type="number"
                          readonly
                          :disabled="!qc.purchaseOrderId"
                        ></v-text-field>
                      </v-flex>
                      <v-flex sm4>
                        <v-text-field
                          name="batchLotNo"
                          label="Batch Lot No"
                          v-model="qc.batchLotNo"
                        ></v-text-field>
                      </v-flex>
                      <v-flex sm4>
                        <v-autocomplete
                          v-if="!qc.purchaseOrderId && status == 'DRAFT'"
                          v-model="qc.countryId"
                          :items="countryList"
                          :hide-no-data="true"
                          color="blue-grey lighten-2"
                          label="Choose Country Of Origin..."
                          item-text="name"
                          item-value="id"
                          menu-props="auto"
                          clearable
                        ></v-autocomplete>
                        <v-text-field
                          v-else
                          name="countryName"
                          label="Origin"
                          v-model="qc.countryName"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex sm4>
                        <v-menu
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <v-text-field
                            slot="activator"
                            label="MFG Date"
                            type="text"
                            prepend-icon="event"
                            v-model="mfgDate"
                            readonly
                          ></v-text-field>
                          <v-date-picker v-model="mfgDate"></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex sm4>
                        <v-menu
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <v-text-field
                            slot="activator"
                            label="EXP Date"
                            type="text"
                            prepend-icon="event"
                            v-model="expDate"
                            readonly
                          ></v-text-field>
                          <v-date-picker v-model="expDate"></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex sm4>
                        <v-text-field
                          name="reference"
                          label="Reference"
                          v-model="qc.reference"
                        ></v-text-field>
                      </v-flex>
                      <v-flex sm4>
                        <v-text-field
                          name="manufacturer"
                          label="Manufacturer"
                          v-model="qc.manufacturer"
                        ></v-text-field>
                      </v-flex>
                      <v-flex sm4>
                        <v-menu
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <v-text-field
                            slot="activator"
                            label="Sampling Date"
                            type="text"
                            prepend-icon="event"
                            v-model="samplingDate"
                            readonly
                          ></v-text-field>
                          <v-date-picker v-model="samplingDate"></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex sm4>
                        <v-menu
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <v-text-field
                            slot="activator"
                            label="Test Completion Date"
                            type="text"
                            prepend-icon="event"
                            v-model="testCompletionDate"
                            readonly
                          ></v-text-field>
                          <v-date-picker
                            v-model="testCompletionDate"
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex sm4>
                        <v-autocomplete
                          v-model="qc.supplierId"
                          :items="supplierList"
                          color="blue-grey lighten-2"
                          label="Choose Supplier..."
                          item-text="companyName"
                          menu-props="auto"
                          item-value="id"
                          :readonly="!!qc.purchaseOrderItemId"
                          :rules="rules.supplierRules"
                        ></v-autocomplete>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn
                    color="error"
                    @click="clear"
                    :disabled="status != 'DRAFT'"
                  >
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :disabled="!valid || status != 'DRAFT'"
                    type="submit"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <PurchaseOrderListDialog
      :showDialog="showPurchaseOrderDialog"
      :params="{
        warehouseId: qc.warehouseId,
        status: 'ပစ္စည်းရရှိပြီးQCစောင့်',
        checkQc: true,
      }"
      @close="closePurchaseOrderDialog"
    ></PurchaseOrderListDialog>

    <ProductListDialog
      :showDialog="showProductListDialog"
      :params="{ isPurchase: true }"
      @close="closeProductDialog"
    ></ProductListDialog>
  </v-container>
</template>

<script>
import { warehouseService } from "../../services/warehouse-service";
import { supplierService } from "../../services/supplier-service";
import PurchaseOrderListDialog from "../purchase-order/PurchaseOrderListDialog.vue";
import { qcService } from "../../services/qc-service";
import { QC } from "../../models/model";
import { QCFormRules } from "../../helpers/validation-rules";
import { commonService } from "../../services/common-service";
import ProductListDialog from "../dialogs/ProductListDialog.vue";
import { countryService } from "../../services/country-service";

export default {
  name: "QCDetail",
  components: { PurchaseOrderListDialog, ProductListDialog },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    breadcrumbs: [
      {
        text: "QC",
        disabled: false,
        to: "qcs",
      },
      {
        text: "QC Detail",
        disabled: true,
      },
    ],
    warehouseList: [],
    supplierList: [],
    qc: new QC(),
    oldQC: new QC(),
    saveLoading: false,
    responseError: "",
    rules: new QCFormRules(),
    showPurchaseOrderDialog: false,
    purchaseOrderItemList: [],
    countryList: [],
    issueDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
    statusList: [
      { label: "DRAFT", value: "DRAFT" },
      { label: "PASS", value: "PASS" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    receivedDate: "",
    mfgDate: "",
    expDate: "",
    samplingDate: "",
    testCompletionDate: "",
    remainingQty: 0,
    status: "DRAFT",
    showProductListDialog: false,
  }),
  created() {
    const id = this.$route.params.id;
    if (id == "new") {
      // new qc
      if (this.user.warehouseId) {
        this.qc.warehouseId = this.user.warehouseId;
      }
    } else {
      this.getQCDetail(id);
    }
    this.getActiveWarehouseList();
    this.getAllSupplier();
    this.getActiveCountry();
  },
  methods: {
    getAllSupplier() {
      supplierService
        .getAllSupplier()
        .then((res) => {
          this.supplierList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getActiveWarehouseList() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.warehouseList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeWarehouse(warehouseId) {
      this.qc.warehouseId = warehouseId;
      this.qc.purchaseOrderId = "";
      this.qc.purchaseOrderNo = "";
      this.purchaseOrderItemList = [];
      this.qc.purchaseOrderItemId = "";
    },
    closePurchaseOrderDialog(purchaseOrder) {
      if (purchaseOrder && purchaseOrder.id) {
        this.qc.purchaseOrderId = purchaseOrder.id;
        this.qc.purchaseOrderNo = purchaseOrder.issueNo;
        this.qc.purchaseOrderItemId = "";
        this.qc.productUnits = [];
        this.qc.factorUnitName = "";
        this.qc.productCode = "";
        this.qc.countryId = "";
        this.qc.countryName = "";
        this.purchaseOrderItemList = [];

        // filter purchase order item lists for qc finished
        purchaseOrder.purchaseOrderItems.forEach((d) => {
          if (d.basicQty > d.qcPassQty) {
            this.purchaseOrderItemList.push(d);
          }
        });
      }

      this.showPurchaseOrderDialog = false;
    },
    searchPOItem(purchaseOrderItemId) {
      if (!purchaseOrderItemId) return null;
      let purchaseOrderItem = commonService.search(
        "id",
        purchaseOrderItemId,
        this.purchaseOrderItemList
      );
      return purchaseOrderItem;
    },
    changePurchaseOrderItem(purchaseOrderItemId) {
      let purchaseOrderItem = this.searchPOItem(purchaseOrderItemId);
      if (purchaseOrderItem) {
        this.qc.productName = purchaseOrderItem.productName;
        this.qc.productCode = purchaseOrderItem.productCode;
        if (purchaseOrderItem.countryId) {
          this.qc.countryId = purchaseOrderItem.countryId;
          this.qc.countryName = purchaseOrderItem.countryName;
        } else {
          this.qc.countryId = "";
          this.qc.countryName = "";
        }
        this.qc.supplierId = purchaseOrderItem.supplierId;
        this.qc.productUnits = purchaseOrderItem.productUnits;
        this.qc.factorUnitName = purchaseOrderItem.factorUnitName;
        this.qc.factor = purchaseOrderItem.factor;
        this.calculateRemainingQty(purchaseOrderItem);
      }
    },
    calculateRemainingQty(poItem) {
      this.remainingQty = (poItem.basicQty - poItem.qcPassQty) / poItem.factor;
    },
    changeUnit(factorUnitName) {
      if (!this.qc.purchaseOrderId) return;
      let productUnit = commonService.search(
        "factorUnitName",
        factorUnitName,
        this.qc.productUnits
      );
      if (productUnit) {
        this.remainingQty =
          (this.remainingQty * this.qc.factor) / productUnit.factor;
        this.qc.factor = productUnit.factor;
      }
    },
    showProductList() {
      if (this.status == "DRAFT") {
        this.showProductListDialog = true;
      }
    },
    closeProductDialog(product) {
      this.showProductListDialog = false;
      if (product && product.id) {
        this.qc.productName = product.name;
        this.qc.productCode = product.code;
        this.qc.productUnits = product.productUnits;

        let pu = commonService.search("basicUnit", true, product.productUnits);
        if (pu && pu.id) {
          this.qc.factorUnitName = pu.factorUnitName;
        }
      }
    },
    getActiveCountry() {
      countryService
        .getCountryByStatus("ACTIVE")
        .then((res) => {
          this.countryList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;

        this.qc.issueDateInMilliSeconds = commonService.convertToMilliseconds(
          this.issueDate
        );
        if (this.receivedDate) {
          this.qc.receivedDateInMilliSeconds =
            commonService.convertToMilliseconds(this.receivedDate);
        }
        if (this.mfgDate) {
          this.qc.mfgDateInMilliSeconds = commonService.convertToMilliseconds(
            this.mfgDate
          );
        }
        if (this.expDate) {
          this.qc.expDateInMilliSeconds = commonService.convertToMilliseconds(
            this.expDate
          );
        }
        if (this.samplingDate) {
          this.qc.samplingDateInMilliSeconds =
            commonService.convertToMilliseconds(this.samplingDate);
        }
        if (this.testCompletionDate) {
          this.qc.testCompletionDateInMilliSeconds =
            commonService.convertToMilliseconds(this.testCompletionDate);
        }

        // deep copy and remove unecessary objects
        let qc = JSON.parse(JSON.stringify(this.qc));
        qc.productUnits = null;
        qc.purchaseOrderItems = null;

        qcService
          .saveQC(qc)
          .then((res) => {
            console.log(res);
            this.goBack();
          })
          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
    getQCDetail(id) {
      qcService
        .getQCDetail(id)
        .then((res) => {
          this.qc = res.data;
          this.oldQC = JSON.parse(JSON.stringify(res.data));
          this.status = this.qc.status;
          this.purchaseOrderItemList = this.qc.purchaseOrderItems;
          this.issueDate = commonService.millisecondToDate(
            this.qc.issueDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          if (this.qc.receivedDateInMilliSeconds) {
            this.receivedDate = commonService.millisecondToDate(
              this.qc.receivedDateInMilliSeconds,
              "YYYY-MM-DD"
            );
          }
          if (this.qc.mfgDateInMilliSeconds) {
            this.mfgDate = commonService.millisecondToDate(
              this.qc.mfgDateInMilliSeconds,
              "YYYY-MM-DD"
            );
          }
          if (this.qc.expDateInMilliSeconds) {
            this.expDate = commonService.millisecondToDate(
              this.qc.expDateInMilliSeconds,
              "YYYY-MM-DD"
            );
          }
          if (this.qc.samplingDateInMilliSeconds) {
            this.samplingDate = commonService.millisecondToDate(
              this.qc.samplingDateInMilliSeconds,
              "YYYY-MM-DD"
            );
          }
          if (this.qc.testCompletionDateInMilliSeconds) {
            this.testCompletionDate = commonService.millisecondToDate(
              this.qc.testCompletionDateInMilliSeconds,
              "YYYY-MM-DD"
            );
          }
          let poItem = this.searchPOItem(this.qc.purchaseOrderItemId);
          this.calculateRemainingQty(poItem);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.qc.id) {
        this.qc = new QC();
        this.qc.warehouseId = this.user.warehouseId;
      } else {
        this.qc = Object.assign({}, this.oldQC);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

